// React
import React, { useState } from 'react';
// MUI
import { Grid } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { immediateToast } from 'utils/toast';
import {
    Field,
    Form,
    setNestedObjectValues,
    withFormik,
} from 'formik';
import { useStoreGatewayMutation } from 'app/store';
import { TextField } from 'components/formik/text-field';
import { getServerErrorMessage, handleServerErrors } from '../../../../utils/utils';
import { GatewaySchema } from './gateway.schema';

const sanitizeGatewayTitle = (value: string) => value.replace(/[A-Za-z]/g, '');

const CreateGatewayTemplate: React.FC<any> = ({
    onClose,
    values,
    validateForm,
    setSubmitting,
    setTouched,
    setErrors,
}): JSX.Element => {
    const [storeGateway, { isLoading }] = useStoreGatewayMutation();
    const [hasSubmitAttempt, setHasSubmitAttempt] = useState(false);

    const handleOnSubmit = async () => {
        setHasSubmitAttempt(true);
        setErrors({});

        const errors = await validateForm();
        setTouched(setNestedObjectValues(errors, true));

        if (Object.keys(errors).length > 0) return;

        try {
            await storeGateway({
                title: values.title,
                website: values.website,
            }).unwrap();

            immediateToast('success', {
                message: 'درخواست درگاه شما ثبت شد',
                timeout: 2000,
            });

            onClose?.();
        } catch (error) {
            immediateToast('error', {
                message: getServerErrorMessage(error),
            });
            handleServerErrors(error, setErrors);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Form onSubmit={(event) => event.preventDefault()}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Field
                            fullWidth
                            component={TextField}
                            name="title"
                            showValidation={hasSubmitAttempt}
                            liveValidation={false}
                            inputSanitizer={sanitizeGatewayTitle}
                            icon={<i className="fa-light fa-store"></i>}
                            label="عنوان درگاه پرداخت"
                            placeholder="لطفا عنوان وب‌سایت خود را وارد کنید"
                            description="نام فارسی کسب و کار خود را جهت نمایش در صفحه بانکی برای پرداخت کننده وارد نمایید."
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Field
                            fullWidth
                            component={TextField}
                            name="website"
                            showValidation={hasSubmitAttempt}
                            liveValidation={false}
                            icon={<i className="fa-light fa-link"></i>}
                            label="آدرس وب‌سایت"
                            placeholder="لطفا آدرس وب‌سایت خود را وارد کنید"
                            description="لطفا آدرس سایت خود را بدون https یا http وارد کنید، مانند : aqayepardakht.ir"
                            sx={{
                                input: {
                                    direction: 'rtl',
                                    textAlign: 'right',
                                },
                            }}
                        />
                    </Grid>
                </Grid>
            </Form>

            <LoadingButton
                fullWidth
                variant="contained"
                loading={isLoading}
                onClick={handleOnSubmit}
                sx={{ mt: 3 }}>
                ایجاد درگاه پرداخت
            </LoadingButton>
        </>
    );
};

const CreateGatewayForm: any = withFormik({
    mapPropsToValues: () => ({
        title: '',
        website: '',
    }),
    validationSchema: GatewaySchema,
    validateOnChange: false,
    validateOnBlur: false,
    validateOnMount: false,
    handleSubmit: () => {},
})(CreateGatewayTemplate);

export { CreateGatewayForm };
